// NOTE: stolen from ActiveSupport
// us_zones = ActiveSupport::TimeZone.all & ActiveSupport::TimeZone.us_zones
// other_zones = other_zones = ActiveSupport::TimeZone.all - us_zones
// puts zones.sort_by { |x| x.now.utc_offset }.map { |x| [x.tzinfo.name, x.name] }.to_h.to_json

export const usTimeZones = {
  'Pacific/Honolulu': 'Hawaii',
  'America/Juneau': 'Alaska',
  'America/Los_Angeles': 'Pacific Time (US & Canada)',
  'America/Phoenix': 'Arizona',
  'America/Denver': 'Mountain Time (US & Canada)',
  'America/Chicago': 'Central Time (US & Canada)',
  'America/New_York': 'Eastern Time (US & Canada)',
  'America/Indiana/Indianapolis': 'Indiana (East)',
};

export const otherTimeZones = {
  'Etc/GMT+12': 'International Date Line West',
  'Pacific/Midway': 'Midway Island',
  'Pacific/Pago_Pago': 'American Samoa',
  'America/Tijuana': 'Tijuana',
  'America/Chihuahua': 'Chihuahua',
  'America/Mazatlan': 'Mazatlan',
  'America/Mexico_City': 'Mexico City',
  'America/Guatemala': 'Central America',
  'America/Monterrey': 'Monterrey',
  'America/Regina': 'Saskatchewan',
  'America/Bogota': 'Bogota',
  'America/Lima': 'Quito',
  'America/La_Paz': 'La Paz',
  'America/Caracas': 'Caracas',
  'America/Guyana': 'Georgetown',
  'America/Puerto_Rico': 'Puerto Rico',
  'America/Halifax': 'Atlantic Time (Canada)',
  'America/Santiago': 'Santiago',
  'America/Sao_Paulo': 'Brasilia',
  'America/Argentina/Buenos_Aires': 'Buenos Aires',
  'America/Godthab': 'Greenland',
  'America/Montevideo': 'Montevideo',
  'America/St_Johns': 'Newfoundland',
  'Atlantic/South_Georgia': 'Mid-Atlantic',
  'Atlantic/Cape_Verde': 'Cape Verde Is.',
  'Atlantic/Azores': 'Azores',
  'Etc/UTC': 'UTC',
  'Europe/Dublin': 'Dublin',
  'Europe/London': 'London',
  'Europe/Lisbon': 'Lisbon',
  'Africa/Monrovia': 'Monrovia',
  'Africa/Casablanca': 'Casablanca',
  'Europe/Amsterdam': 'Amsterdam',
  'Europe/Belgrade': 'Belgrade',
  'Europe/Berlin': 'Berlin',
  'Europe/Zurich': 'Zurich',
  'Europe/Bratislava': 'Bratislava',
  'Europe/Brussels': 'Brussels',
  'Europe/Budapest': 'Budapest',
  'Europe/Copenhagen': 'Copenhagen',
  'Europe/Ljubljana': 'Ljubljana',
  'Europe/Madrid': 'Madrid',
  'Europe/Paris': 'Paris',
  'Europe/Prague': 'Prague',
  'Europe/Rome': 'Rome',
  'Europe/Sarajevo': 'Sarajevo',
  'Europe/Skopje': 'Skopje',
  'Europe/Stockholm': 'Stockholm',
  'Europe/Vienna': 'Vienna',
  'Europe/Warsaw': 'Warsaw',
  'Africa/Algiers': 'West Central Africa',
  'Europe/Zagreb': 'Zagreb',
  'Europe/Vilnius': 'Vilnius',
  'Europe/Bucharest': 'Bucharest',
  'Africa/Cairo': 'Cairo',
  'Africa/Harare': 'Harare',
  'Europe/Helsinki': 'Helsinki',
  'Asia/Jerusalem': 'Jerusalem',
  'Europe/Kaliningrad': 'Kaliningrad',
  'Europe/Kiev': 'Kyiv',
  'Africa/Johannesburg': 'Pretoria',
  'Europe/Riga': 'Riga',
  'Europe/Sofia': 'Sofia',
  'Europe/Tallinn': 'Tallinn',
  'Europe/Athens': 'Athens',
  'Asia/Kuwait': 'Kuwait',
  'Asia/Baghdad': 'Baghdad',
  'Europe/Istanbul': 'Istanbul',
  'Europe/Minsk': 'Minsk',
  'Europe/Moscow': 'St. Petersburg',
  'Africa/Nairobi': 'Nairobi',
  'Asia/Riyadh': 'Riyadh',
  'Asia/Tehran': 'Tehran',
  'Asia/Muscat': 'Muscat',
  'Europe/Samara': 'Samara',
  'Asia/Tbilisi': 'Tbilisi',
  'Europe/Volgograd': 'Volgograd',
  'Asia/Yerevan': 'Yerevan',
  'Asia/Baku': 'Baku',
  'Asia/Kabul': 'Kabul',
  'Asia/Yekaterinburg': 'Ekaterinburg',
  'Asia/Karachi': 'Karachi',
  'Asia/Tashkent': 'Tashkent',
  'Asia/Kolkata': 'New Delhi',
  'Asia/Colombo': 'Sri Jayawardenepura',
  'Asia/Kathmandu': 'Kathmandu',
  'Asia/Almaty': 'Almaty',
  'Asia/Dhaka': 'Dhaka',
  'Asia/Urumqi': 'Urumqi',
  'Asia/Rangoon': 'Rangoon',
  'Asia/Bangkok': 'Hanoi',
  'Asia/Jakarta': 'Jakarta',
  'Asia/Krasnoyarsk': 'Krasnoyarsk',
  'Asia/Novosibirsk': 'Novosibirsk',
  'Asia/Kuala_Lumpur': 'Kuala Lumpur',
  'Asia/Shanghai': 'Beijing',
  'Asia/Chongqing': 'Chongqing',
  'Asia/Hong_Kong': 'Hong Kong',
  'Asia/Irkutsk': 'Irkutsk',
  'Australia/Perth': 'Perth',
  'Asia/Singapore': 'Singapore',
  'Asia/Taipei': 'Taipei',
  'Asia/Ulaanbaatar': 'Ulaanbaatar',
  'Asia/Tokyo': 'Osaka',
  'Asia/Seoul': 'Seoul',
  'Asia/Yakutsk': 'Yakutsk',
  'Australia/Darwin': 'Darwin',
  'Asia/Vladivostok': 'Vladivostok',
  'Australia/Brisbane': 'Brisbane',
  'Pacific/Guam': 'Guam',
  'Pacific/Port_Moresby': 'Port Moresby',
  'Australia/Adelaide': 'Adelaide',
  'Australia/Melbourne': 'Canberra',
  'Australia/Sydney': 'Sydney',
  'Asia/Magadan': 'Magadan',
  'Pacific/Noumea': 'New Caledonia',
  'Pacific/Guadalcanal': 'Solomon Is.',
  'Australia/Hobart': 'Hobart',
  'Asia/Srednekolymsk': 'Srednekolymsk',
  'Asia/Kamchatka': 'Kamchatka',
  'Pacific/Fiji': 'Fiji',
  'Pacific/Majuro': 'Marshall Is.',
  'Pacific/Auckland': 'Wellington',
  'Pacific/Fakaofo': 'Tokelau Is.',
  'Pacific/Tongatapu': "Nuku'alofa",
  'Pacific/Chatham': 'Chatham Is.',
  'Pacific/Apia': 'Samoa',
};
